<div data-testid="SUBSYS2_DASHBOARD_CALENDAR_DAY" class="custom-day p-0" [class.selected]="focused">
	<div class="d-flex justify-content-between">
		<div class="btn-light" [class.focused]="focused" [class.bg-primary]="focused"
			[class.text-muted]="date?.month !== currentMonth">
			<strong>{{ date?.day }}</strong>
		</div>
	</div>
	<calendar-events [events]="data?.items" />
</div>